import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Components
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';

// Customer Pages
import Home from './pages/Home';
import Explore from './pages/Explore';
import ProductDetail from './pages/ProductDetail'; 
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Wishlist from './pages/Wishlist';

// Admin Pages
import AdminDashboard from './pages/AdminDashboard';
import AdminStock from './pages/AdminStock';
import AdminRecycleBin from './pages/AdminRecycleBin';
import AdminOrders from './pages/AdminOrders';
import AdminSettings from './pages/AdminSettings';

function App() {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (product, qty = 1) => {
    const exist = cartItems.find((x) => x._id === product._id);
    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x._id === product._id ? { ...exist, quantity: exist.quantity + qty } : x
        )
      );
    } else {
      setCartItems([...cartItems, { ...product, quantity: qty }]);
    }
  };

  return (
    <Router>
      <Routes>
        {/* Customer Portal */}
        <Route path="/" element={<><Navbar cartItems={cartItems} /><Home /><BottomNav cartItems={cartItems} /></>} />

        <Route path="/explore" element={<><Navbar cartItems={cartItems} /><Explore cartItems={cartItems} addToCart={addToCart} /><BottomNav cartItems={cartItems} /></>} />

        <Route path="/product/:id" element={<><Navbar cartItems={cartItems} /><ProductDetail cartItems={cartItems} addToCart={addToCart} /><BottomNav cartItems={cartItems} /></>} />

        <Route path="/cart" element={<><Navbar cartItems={cartItems} /><Cart cartItems={cartItems} setCartItems={setCartItems} /><BottomNav cartItems={cartItems} /></>} />

        <Route path="/wishlist" element={<><Navbar cartItems={cartItems} /><Wishlist /><BottomNav cartItems={cartItems} /></>} />
        
        <Route path="/checkout" element={<><Navbar cartItems={cartItems} /><Checkout cartItems={cartItems} /><BottomNav cartItems={cartItems} /></>} />
        
        <Route path="/login" element={<Login />} />

        {/* Protected Admin Portal */}
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminLayout><AdminDashboard /></AdminLayout>
          </ProtectedRoute>
        } />

        <Route path="/admin/stock" element={
          <ProtectedRoute>
            <AdminLayout><AdminStock /></AdminLayout>
          </ProtectedRoute>
        } />

        <Route path="/admin/recycle" element={
          <ProtectedRoute>
            <AdminLayout><AdminRecycleBin /></AdminLayout>
          </ProtectedRoute>
        } />

        <Route path="/admin/orders" element={
          <ProtectedRoute>
            <AdminLayout><AdminOrders /></AdminLayout>
          </ProtectedRoute>
        } />

        <Route path="/admin/settings" element={
          <ProtectedRoute>
            <AdminLayout><AdminSettings /></AdminLayout>
          </ProtectedRoute>
        } />

      </Routes>
    </Router>
  );
}

export default App;